/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: 3Gf4zc1YpP_7

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { Dialog } from "@plasmicpkgs/radix-ui";
import { SheetContent } from "@plasmicpkgs/radix-ui";
import { DialogTitle } from "@plasmicpkgs/radix-ui";
import MobileDrawerItem from "../../MobileDrawerItem"; // plasmic-import: Kb3kPKRcQbBm/component
import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import { DialogClose } from "@plasmicpkgs/radix-ui";

import { useScreenVariants as useScreenVariantsgibwEjXEmhF1 } from "./PlasmicGlobalVariant__Mobile"; // plasmic-import: GIBWEjXEmhF1/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicMobileDrawer.module.css"; // plasmic-import: 3Gf4zc1YpP_7/css

import Icon3Icon from "./icons/PlasmicIcon__Icon3"; // plasmic-import: ASrk5vWaGnLc/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon
import Icon70Icon from "./icons/PlasmicIcon__Icon70"; // plasmic-import: JHDtTb79YhfA/icon

createPlasmicElementProxy;

export type PlasmicMobileDrawer__VariantMembers = {};
export type PlasmicMobileDrawer__VariantsArgs = {};
type VariantPropType = keyof PlasmicMobileDrawer__VariantsArgs;
export const PlasmicMobileDrawer__VariantProps = new Array<VariantPropType>();

export type PlasmicMobileDrawer__ArgsType = {
  open?: boolean;
  onOpenChange?: (val: boolean) => void;
  dialogBody?: React.ReactNode;
  trigger?: React.ReactNode;
  onContactClick?: () => void;
};
type ArgPropType = keyof PlasmicMobileDrawer__ArgsType;
export const PlasmicMobileDrawer__ArgProps = new Array<ArgPropType>(
  "open",
  "onOpenChange",
  "dialogBody",
  "trigger",
  "onContactClick"
);

export type PlasmicMobileDrawer__OverridesType = {
  mobileDrawer?: Flex__<typeof Dialog>;
  drawerContent?: Flex__<typeof SheetContent>;
  dialogTitle?: Flex__<typeof DialogTitle>;
  header?: Flex__<"header">;
  logo?: Flex__<"a"> & Partial<LinkProps>;
  logoSvg?: Flex__<typeof PlasmicImg__>;
  dialogClose?: Flex__<typeof DialogClose>;
  closeDrawerButton?: Flex__<"button">;
  closeIcon?: Flex__<"svg">;
};

export interface DefaultMobileDrawerProps {
  open?: boolean;
  onOpenChange?: (val: boolean) => void;
  dialogBody?: React.ReactNode;
  trigger?: React.ReactNode;
  onContactClick?: () => void;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicMobileDrawer__RenderFunc(props: {
  variants: PlasmicMobileDrawer__VariantsArgs;
  args: PlasmicMobileDrawer__ArgsType;
  overrides: PlasmicMobileDrawer__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "mobileDrawer.open",
        type: "writable",
        variableType: "boolean",

        valueProp: "open",
        onChangeProp: "onOpenChange"
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    mobile: useScreenVariantsgibwEjXEmhF1()
  });

  return (
    <Dialog
      data-plasmic-name={"mobileDrawer"}
      data-plasmic-override={overrides.mobileDrawer}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "__wab_instance",
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.mobileDrawer
      )}
      defaultOpen={
        hasVariant(globalVariants, "mobile", "tabletLandscape") ? false : false
      }
      onOpenChange={async (...eventArgs: any) => {
        generateStateOnChangeProp($state, ["mobileDrawer", "open"]).apply(
          null,
          eventArgs
        );
      }}
      open={generateStateValueProp($state, ["mobileDrawer", "open"])}
      themeResetClass={classNames(
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens
      )}
      triggerSlot={renderPlasmicSlot({
        defaultContents: (
          <button
            aria-label={"Open drawer"}
            className={classNames(
              projectcss.all,
              projectcss.button,
              sty.button___4M9Nx
            )}
            title={"Open drawer"}
          >
            <Icon3Icon
              aria-label={"Open"}
              className={classNames(projectcss.all, sty.svg__yuyAu)}
              role={"img"}
            />
          </button>
        ),
        value: args.trigger,
        className: classNames(sty.slotTargetTrigger)
      })}
    >
      <SheetContent
        data-plasmic-name={"drawerContent"}
        data-plasmic-override={overrides.drawerContent}
        className={classNames("__wab_instance", sty.drawerContent)}
        enterAnimations={["slide-in-from-right"]}
        enterDuration={0.3}
        exitAnimations={["slide-out-to-right"]}
        exitDuration={0.25}
        themeResetClass={classNames(
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          projectcss.plasmic_tokens
        )}
      >
        <DialogTitle
          data-plasmic-name={"dialogTitle"}
          data-plasmic-override={overrides.dialogTitle}
          className={classNames("__wab_instance", sty.dialogTitle)}
        >
          <Stack__
            as={"header"}
            data-plasmic-name={"header"}
            data-plasmic-override={overrides.header}
            hasGap={true}
            className={classNames(projectcss.all, sty.header)}
          >
            <PlasmicLink__
              data-plasmic-name={"logo"}
              data-plasmic-override={overrides.logo}
              aria-label={"Home"}
              className={classNames(projectcss.all, projectcss.a, sty.logo)}
              component={Link}
              href={`/`}
              platform={"nextjs"}
              title={"Home"}
            >
              <PlasmicImg__
                data-plasmic-name={"logoSvg"}
                data-plasmic-override={overrides.logoSvg}
                alt={""}
                className={classNames(sty.logoSvg)}
                displayHeight={"29.83px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"170.67px"}
                loader={"plasmic"}
                loading={"lazy"}
                src={{
                  src: "https://site-assets.plasmic.app/f7a2645d1f520625588f9e3581d30856.svg",
                  fullWidth: 170.666,
                  fullHeight: 29.831,
                  aspectRatio: 5.7
                }}
              />
            </PlasmicLink__>
          </Stack__>
        </DialogTitle>
        {renderPlasmicSlot({
          defaultContents: (
            <div className={classNames(projectcss.all, sty.freeBox__yVUvP)}>
              <Stack__
                as={"nav"}
                hasGap={true}
                className={classNames(projectcss.all, sty.nav__veimj)}
              >
                {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                  (() => {
                    try {
                      return [
                        {
                          name: "Home",
                          link: "/"
                        },
                        //{
                        //     name: "Solutions",
                        //     subitems:
                        //     [
                        //        {
                        //         name: "GME Programs",
                        //         link: "/gme-programs"
                        //        },
                        //        {
                        //         name: "Nursing Programs",
                        //         link: "/nursing-programs"
                        //        },
                        //        {
                        //         name: "Physician Assistant Programs",
                        //         link: "/physician-assistant-programs"
                        //        }
                        //     ]
                        // },
                        // {
                        //     name: "Products",
                        //     subitems:
                        //     [
                        //        {
                        //         name: "MyEvaluations",
                        //         caption: "Repellat animi dicta culpa aut exercitationem iusto veritatis.",
                        //         link: "/my-evaluations"
                        //        },
                        //        {
                        //         name: "MyCME",
                        //         caption: "Repellat animi dicta culpa aut exercitationem iusto veritatis.",
                        //         link: "/my-cme"
                        //        },
                        //        {
                        //         name: "MyGME Fiscal",
                        //         caption: "Repellat animi dicta culpa aut exercitationem iusto veritatis.",
                        //         link: "/mygme-fiscal"
                        //        }
                        //     ]
                        // },
                        {
                          name: "Features",
                          link: "/features"
                        },
                        // {
                        //     name: "Resources",
                        //     subitems:
                        //     [
                        //        {
                        //         name: "Case Studies",
                        //         link: "/case-studies"
                        //        },
                        //        {
                        //         name: "Integrations",
                        //         link: "/integrations"
                        //        },
                        //        {
                        //         name: "Security & Privacy",
                        //         link: "/security-and-privacy"
                        //        },
                        //                   {
                        //         name: "Support",
                        //         link: "/support"
                        //        },
                        //                   {
                        //         name: "Documents",
                        //         link: "/documents"
                        //        },
                        //        {
                        //         name: "About Us",
                        //         link: "/about-us"
                        //        }
                        //     ]
                        // },
                        {
                          name: "Pricing",
                          link: "/pricing"
                        },
                        {
                          name: "Contact",
                          link: "/contact"
                        }
                      ];
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()
                ).map((__plasmic_item_0, __plasmic_idx_0) => {
                  const currentItem = __plasmic_item_0;
                  const currentIndex = __plasmic_idx_0;
                  return (
                    <MobileDrawerItem
                      active={(() => {
                        try {
                          return window.location.pathname === currentItem.link;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()}
                      className={classNames(
                        "__wab_instance",
                        sty.mobileDrawerItem__pvokb
                      )}
                      item={(() => {
                        try {
                          return currentItem;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return undefined;
                          }
                          throw e;
                        }
                      })()}
                      key={currentIndex}
                      onContactClick={async () => {
                        const $steps = {};

                        $steps["runOnContactClick"] = true
                          ? (() => {
                              const actionArgs = {
                                eventRef: $props["onContactClick"]
                              };
                              return (({ eventRef, args }) => {
                                return eventRef?.(...(args ?? []));
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["runOnContactClick"] != null &&
                          typeof $steps["runOnContactClick"] === "object" &&
                          typeof $steps["runOnContactClick"].then === "function"
                        ) {
                          $steps["runOnContactClick"] = await $steps[
                            "runOnContactClick"
                          ];
                        }
                      }}
                      withAccordion={(() => {
                        try {
                          return currentItem.subitems.length > 0;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()}
                    />
                  );
                })}
              </Stack__>
              <Stack__
                as={"div"}
                hasGap={true}
                className={classNames(projectcss.all, sty.freeBox__lNwSb)}
              >
                <Stack__
                  as={"div"}
                  hasGap={true}
                  className={classNames(projectcss.all, sty.freeBox__jvgqr)}
                >
                  <Button
                    aria-label={"Request demo"}
                    className={classNames("__wab_instance", sty.button__ypcQz)}
                    color={"primary"}
                    link={
                      "https://meetings.hubspot.com/david-p-melamed-md/request-a-demo"
                    }
                    size={"large"}
                    target={true}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__jl62I
                      )}
                    >
                      {"Request demo"}
                    </div>
                  </Button>
                  <Button
                    aria-label={"Log in"}
                    className={classNames("__wab_instance", sty.button__aoZmC)}
                    color={"sky"}
                    link={`/login`}
                    size={"large"}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__dArmR
                      )}
                    >
                      {"Log in"}
                    </div>
                  </Button>
                </Stack__>
                <div className={classNames(projectcss.all, sty.freeBox__z0Spb)}>
                  <PlasmicLink__
                    aria-label={"Open MyEvaluations X page"}
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.link__uGOnK
                    )}
                    component={Link}
                    href={"https://twitter.com/myevaluations/media"}
                    platform={"nextjs"}
                    target={"_blank"}
                    title={"Open MyEvaluations X page"}
                  >
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__gM1TB)}
                      displayHeight={"32px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"none"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"32px"}
                      loader={"plasmic"}
                      loading={"lazy"}
                      src={{
                        src: "https://site-assets.plasmic.app/5c16cc6098d8223f6ee21c936cbdbc43.svg",
                        fullWidth: 24,
                        fullHeight: 24,
                        aspectRatio: 1
                      }}
                    />
                  </PlasmicLink__>
                  <PlasmicLink__
                    aria-label={"Open MyEvaluations Facebook page"}
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.link__kNfWw
                    )}
                    component={Link}
                    href={"https://web.facebook.com/myevaluations"}
                    platform={"nextjs"}
                    target={"_blank"}
                    title={"Open MyEvaluations Facebook page"}
                  >
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__jLZl)}
                      displayHeight={"32px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"none"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"32px"}
                      loader={"plasmic"}
                      loading={"lazy"}
                      src={{
                        src: "https://site-assets.plasmic.app/24dbb12092ac2a0b739d01ca30614897.svg",
                        fullWidth: 24,
                        fullHeight: 24,
                        aspectRatio: 1
                      }}
                    />
                  </PlasmicLink__>
                  <PlasmicLink__
                    aria-label={"Open MyEvaluations Instagram page"}
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.link___6TjO9
                    )}
                    component={Link}
                    href={"https://www.instagram.com/myevaluations/"}
                    platform={"nextjs"}
                    target={"_blank"}
                    title={"Open MyEvaluations Instagram page"}
                  >
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__ueLvf)}
                      displayHeight={"32px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"none"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"32px"}
                      loader={"plasmic"}
                      loading={"lazy"}
                      src={{
                        src: "https://site-assets.plasmic.app/bdd639079ea2546ece1ab194ad192475.svg",
                        fullWidth: 24,
                        fullHeight: 24,
                        aspectRatio: 1
                      }}
                    />
                  </PlasmicLink__>
                  <PlasmicLink__
                    aria-label={"Open MyEvaluations LinkedIn page"}
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.link___4WgU7
                    )}
                    component={Link}
                    href={
                      "https://www.linkedin.com/company/myevaluations.com-inc/?viewAsMember=true"
                    }
                    platform={"nextjs"}
                    title={"Open MyEvaluations LinkedIn page"}
                  >
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__bGivt)}
                      displayHeight={"32px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"none"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"32px"}
                      loader={"plasmic"}
                      loading={"lazy"}
                      src={{
                        src: "https://site-assets.plasmic.app/1542355768a34cbafbf427680e35942f.svg",
                        fullWidth: 24,
                        fullHeight: 24,
                        aspectRatio: 1
                      }}
                    />
                  </PlasmicLink__>
                  <PlasmicLink__
                    aria-label={"Open MyEvaluations Threads page"}
                    className={classNames(
                      projectcss.all,
                      projectcss.a,
                      sty.link__noTbn
                    )}
                    component={Link}
                    href={"https://www.threads.net/@myevaluations"}
                    platform={"nextjs"}
                    target={"_blank"}
                    title={"Open MyEvaluations Threads page"}
                  >
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img___0JtcZ)}
                      displayHeight={"32px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"none"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"32px"}
                      loader={"plasmic"}
                      loading={"lazy"}
                      onClick={async event => {
                        const $steps = {};

                        $steps["goToPage"] = true
                          ? (() => {
                              const actionArgs = { destination: "" };
                              return (({ destination }) => {
                                if (
                                  typeof destination === "string" &&
                                  destination.startsWith("#")
                                ) {
                                  document
                                    .getElementById(destination.substr(1))
                                    .scrollIntoView({ behavior: "smooth" });
                                } else {
                                  __nextRouter?.push(destination);
                                }
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["goToPage"] != null &&
                          typeof $steps["goToPage"] === "object" &&
                          typeof $steps["goToPage"].then === "function"
                        ) {
                          $steps["goToPage"] = await $steps["goToPage"];
                        }
                      }}
                      src={{
                        src: "https://site-assets.plasmic.app/0c6bcef4caa3daf40c5ce4a872fcc13b.svg",
                        fullWidth: 24,
                        fullHeight: 24,
                        aspectRatio: 1
                      }}
                    />
                  </PlasmicLink__>
                </div>
              </Stack__>
            </div>
          ),
          value: args.dialogBody
        })}
        <DialogClose
          data-plasmic-name={"dialogClose"}
          data-plasmic-override={overrides.dialogClose}
          className={classNames("__wab_instance", sty.dialogClose)}
        >
          <button
            data-plasmic-name={"closeDrawerButton"}
            data-plasmic-override={overrides.closeDrawerButton}
            aria-label={"Close drawer"}
            className={classNames(
              projectcss.all,
              projectcss.button,
              sty.closeDrawerButton
            )}
            ref={ref => {
              $refs["closeDrawerButton"] = ref;
            }}
            title={"Close drawer"}
          >
            <Icon70Icon
              data-plasmic-name={"closeIcon"}
              data-plasmic-override={overrides.closeIcon}
              aria-label={"Close"}
              className={classNames(projectcss.all, sty.closeIcon)}
              role={"img"}
            />
          </button>
        </DialogClose>
      </SheetContent>
    </Dialog>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  mobileDrawer: [
    "mobileDrawer",
    "drawerContent",
    "dialogTitle",
    "header",
    "logo",
    "logoSvg",
    "dialogClose",
    "closeDrawerButton",
    "closeIcon"
  ],
  drawerContent: [
    "drawerContent",
    "dialogTitle",
    "header",
    "logo",
    "logoSvg",
    "dialogClose",
    "closeDrawerButton",
    "closeIcon"
  ],
  dialogTitle: ["dialogTitle", "header", "logo", "logoSvg"],
  header: ["header", "logo", "logoSvg"],
  logo: ["logo", "logoSvg"],
  logoSvg: ["logoSvg"],
  dialogClose: ["dialogClose", "closeDrawerButton", "closeIcon"],
  closeDrawerButton: ["closeDrawerButton", "closeIcon"],
  closeIcon: ["closeIcon"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  mobileDrawer: typeof Dialog;
  drawerContent: typeof SheetContent;
  dialogTitle: typeof DialogTitle;
  header: "header";
  logo: "a";
  logoSvg: typeof PlasmicImg__;
  dialogClose: typeof DialogClose;
  closeDrawerButton: "button";
  closeIcon: "svg";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicMobileDrawer__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicMobileDrawer__VariantsArgs;
    args?: PlasmicMobileDrawer__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicMobileDrawer__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicMobileDrawer__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMobileDrawer__ArgProps,
          internalVariantPropNames: PlasmicMobileDrawer__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicMobileDrawer__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "mobileDrawer") {
    func.displayName = "PlasmicMobileDrawer";
  } else {
    func.displayName = `PlasmicMobileDrawer.${nodeName}`;
  }
  return func;
}

export const PlasmicMobileDrawer = Object.assign(
  // Top-level PlasmicMobileDrawer renders the root element
  makeNodeComponent("mobileDrawer"),
  {
    // Helper components rendering sub-elements
    drawerContent: makeNodeComponent("drawerContent"),
    dialogTitle: makeNodeComponent("dialogTitle"),
    header: makeNodeComponent("header"),
    logo: makeNodeComponent("logo"),
    logoSvg: makeNodeComponent("logoSvg"),
    dialogClose: makeNodeComponent("dialogClose"),
    closeDrawerButton: makeNodeComponent("closeDrawerButton"),
    closeIcon: makeNodeComponent("closeIcon"),

    // Metadata about props expected for PlasmicMobileDrawer
    internalVariantProps: PlasmicMobileDrawer__VariantProps,
    internalArgProps: PlasmicMobileDrawer__ArgProps
  }
);

export default PlasmicMobileDrawer;
/* prettier-ignore-end */
